const MODAL_ROOT = "line-spacing-modal";
const TEXT_BUTTON_LINE_SPACING = "text-button-line-spacing";
const PREDEFINED_SPACING_OPTION = "predefined-spacing-option";
const SPACING_SELECTOR_BUTTON = "spacing-selector-button";
const LINE_SPACING_INPUT = "line-spacing-input";
const BEFORE_PARAGRAPH_INPUT = "before-paragraph-input";
const AFTER_PARAGRAPH_INPUT = "after-paragraph-input";
export {
  AFTER_PARAGRAPH_INPUT,
  BEFORE_PARAGRAPH_INPUT,
  LINE_SPACING_INPUT,
  MODAL_ROOT,
  PREDEFINED_SPACING_OPTION,
  SPACING_SELECTOR_BUTTON,
  TEXT_BUTTON_LINE_SPACING
};
//# sourceMappingURL=data-hooks.js.map
